import CleaningData from "../../../components/cleaning/cleaning-data";
import Page from "../../page";

const CleaningPage = () => {
  return (
    <Page>
      <CleaningData />
    </Page>
  );
};

export default CleaningPage;
